var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.loading)?_c('v-progress-circular',{attrs:{"size":"20","color":"#409EFF","indeterminate":""}}):_vm._e(),_c('v-icon',{style:({opacity: _vm.value ? 1.0 : 0.1}),attrs:{"color":_vm.value ? _vm.color : 'grey',"aria-checked":_vm.value,"aria-readonly":true,"role":"checkbox"}},[_vm._v(" mdi-check ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }